// Country data
export const countries = [
    {
      code: "EG",
      name: "Egypt",
      dial: "+20",
      flag: "🇪🇬",
      regex: /^1[0125]\d{8}$/, // 10 digits, starts with 10, 11, 12, or 15
      // Examples:
      // ✅ Correct: 1012345678, 1112345678, 1212345678, 1512345678
      // ❌ Wrong: 0912345678, 1312345678, 101234567, 10123456789
    },
    {
      code: "SA",
      name: "Saudi Arabia",
      dial: "+966",
      flag: "🇸🇦",
      regex: /^5\d{8}$/, // 9 digits, starts with 5
      // Examples:
      // ✅ Correct: 501234567, 551234567, 591234567
      // ❌ Wrong: 401234567, 601234567, 50123456, 5012345678
    },
    {
      code: "AE",
      name: "United Arab Emirates",
      dial: "+971",
      flag: "🇦🇪",
      regex: /^5[024568]\d{7}$/, // 9 digits, starts with 50, 52, 54, 55, 56, 58
      // Examples:
      // ✅ Correct: 501234567, 521234567, 541234567, 551234567, 561234567, 581234567
      // ❌ Wrong: 511234567, 531234567, 571234567, 591234567, 50123456, 5012345678
    },
  ];
  
  export type countryCode = "SA" | "EG" | "AE";